import React from "react";
import icon_last_edit from "../../Assets/svg/icon_last_edit.svg";

export default function C_V_A_DATE({ value, inPopup = false }) {
  // Helper function to handle nulls and format the date natively
  const getFormattedDate = (val) => {
    // 1. Handle empty strings, undefined, null, and the string "undefined"
    if (
      val === "" ||
      val === undefined ||
      val === null ||
      val === "undefined"
    ) {
      return "-";
    }

    // 2. Parse the value into a Date object
    const dateObj = new Date(val);

    // 3. Check if the parsed date is valid
    if (!isNaN(dateObj.getTime())) {
      // 4. Format using Indonesian locale (id-ID) with date AND time
      // Example output: "17 Agustus 1945 16.24"
      return dateObj.toLocaleString("id-ID", {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    }

    // Fallback: if it has a value but isn't a valid date, return the raw string
    return String(val);
  };

  const displayValue = getFormattedDate(value);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "6px",
        width: "100%",
        height: "100%",
        overflow: "hidden",
        // Adaptive styling for Popup vs Table
        padding: inPopup ? "8px" : "0 4px",
        backgroundColor: inPopup ? "#f8fafc" : "transparent",
        border: inPopup ? "1px solid #e2e8f0" : "none",
        borderRadius: inPopup ? "4px" : "0",
        boxSizing: "border-box",
        cursor: inPopup ? "not-allowed" : "default",
      }}
    >
      <div
        className="badge_small background_grey_light"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          margin: 0,
          padding: "2px 4px",
          borderRadius: "4px",
          opacity: inPopup ? 0.7 : 1, // slightly dim the badge in popup
        }}
        title="Calculated Formula"
      >
        <img
          src={icon_last_edit}
          alt="Formula"
          style={{ width: "12px", height: "12px", objectFit: "contain" }}
        />
      </div>

      <span
        title={displayValue !== "-" ? displayValue : ""} // Avoid showing "-" as a tooltip
        style={{
          display: "block",
          textAlign: "left", // Adjusted to left for text display
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          width: "100%",
          lineHeight: "1.5",
          fontSize: "12px",
          color: inPopup ? "#64748b" : "inherit", // Make text look "disabled" in popup
        }}
      >
        {displayValue}
      </span>
    </div>
  );
}
